
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
    name: 'StepTemp'
})
export default class StepTemp extends Vue {
  @Prop({ default: 0 }) active!: number;
  @Prop({ default: () => { return [] } }) stepList!: { key?: number; title?: string }[] // 步骤列表
  activeIndex = 0

  @Watch('stepList', { deep: true, immediate: true })
  onStepListChange () {
    const targetIndex = this.stepList.findIndex(i => i.key === this.active)
    this.activeIndex = targetIndex > -1 ? (targetIndex === (this.stepList.length - 1) ? (targetIndex + 1) : targetIndex) : this.activeIndex
    // console.log('active ***', this.active, this.stepList, this.activeIndex)
  }
}
